import * as Redux from 'redux';
import { ThunkAction } from 'redux-thunk';
import { AsyncThunkDispatch } from '@ordermentum/ui-definitions';

type Action = Redux.AnyAction;

export type Dispatcher = (
  action: Action
) => (dispatch: AsyncThunkDispatch<Action>) => void;

// See:
// https://github.com/piotrwitek/react-redux-typescript-guide/blob/master/playground/typings/redux-thunk/index.d.ts
export type DispatchToProps<M extends Redux.ActionCreatorsMapObject<any>> = {
  [N in keyof M]: ReturnType<M[N]> extends ThunkAction<any, any, any, any>
    ? (...args: Parameters<M[N]>) => ReturnType<ReturnType<M[N]>>
    : M[N];
};

export const dispatcher: Dispatcher = action => dispatch => dispatch(action);

export default dispatcher;
